import { getDateTime } from 'src/utils/getDateTime';
import { plural } from 'src/utils/plural';
import { validateTimeRange } from 'src/utils/validations/validateTimeRange';

const maxDurationInDays = 60;

export interface DateBounds {
  min: Date | undefined;
  max: Date | undefined;
}

export const calculateDateBounds = (timezoneOffset: number): DateBounds => {
  const min = getDateTime({
    timezoneOffset,
  });
  min.setHours(0);
  min.setMinutes(0);
  min.setSeconds(0);
  min.setMilliseconds(0);
  const max = new Date(min);
  max.setDate(max.getDate() + maxDurationInDays);

  return { min, max };
};

export const minIntervalMinutes = 15;
const minIntervalMs = minIntervalMinutes * 60 * 1000;
const errorMessage = `Не менее ${minIntervalMinutes} ${plural(
  minIntervalMinutes,
  {
    zero: 'минут',
    one: 'минуты',
    two: 'минут',
    few: 'минуты',
    many: 'минут',
    other: 'минут',
  },
)}`;

export interface CalculateRoomsTimeErrorParams {
  date: string | undefined;
  from: string | undefined;
  to: string | undefined;
  timezoneOffset: number | undefined;
}

export const calculateRoomsTimeError = ({
  date,
  from,
  to,
  timezoneOffset,
}: CalculateRoomsTimeErrorParams): string | undefined => {
  return validateTimeRange({
    date,
    from,
    to,
    diffMs: minIntervalMs,
    message: errorMessage,
    timezoneOffset,
    allowEndLessThanStart: true,
  });
};
